export { default as FollowUpDialog } from './follow-up-dialog.component';
